import { useEffect } from "react";

const BRAND = "QaTestology";

export default function useDocumentTitle(pageName) {
  useEffect(() => {
    document.title = pageName ? `${BRAND} — ${pageName}` : BRAND;
  }, [pageName]);
}
